import {
  Grid,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import DescriptionIcon from "@mui/icons-material/Description";
import StorageIcon from "@mui/icons-material/Storage";
import ToggleOnIcon from "@mui/icons-material/ToggleOn";
import SummarizeIcon from "@mui/icons-material/Summarize";
import ExpandMore from "@mui/icons-material/ExpandMore";

import Collapse from "@mui/material/Collapse";
import "../assets/css/style.css";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import CampaignRoundedIcon from "@mui/icons-material/CampaignRounded";
import Inventory2Icon from "@mui/icons-material/Inventory2";

import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import ListAltIcon from "@mui/icons-material/ListAlt";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import ShoppingCartRounded from "@mui/icons-material/ShoppingCartRounded";
import ListAltRounded from "@mui/icons-material/ListAltRounded";
import ReceiptLongRounded from "@mui/icons-material/ReceiptLongRounded";
import GroupRounded from "@mui/icons-material/GroupRounded";
import StorefrontRounded from "@mui/icons-material/StorefrontRounded";
import StoreMallDirectoryIcon from "@mui/icons-material/StoreMallDirectory";
import DescriptionRounded from "@mui/icons-material/DescriptionRounded";
import SummarizeRounded from "@mui/icons-material/SummarizeRounded";
import SettingsRounded from "@mui/icons-material/SettingsRounded";
import BusinessIcon from "@mui/icons-material/Business";
import BadgeIcon from "@mui/icons-material/Badge";
import HistoryIcon from "@mui/icons-material/History";
import AddBoxIcon from "@mui/icons-material/AddBox";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import AssessmentIcon from "@mui/icons-material/Assessment";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import EditNoteIcon from "@mui/icons-material/EditNote";
import FolderOpenIcon from "@mui/icons-material/FolderOpen";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import TrackChangesIcon from "@mui/icons-material/TrackChanges";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import DangerousIcon from "@mui/icons-material/Dangerous";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BookmarksIcon from "@mui/icons-material/Bookmarks";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import PolicyIcon from "@mui/icons-material/Policy";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SwapCallsIcon from "@mui/icons-material/SwapCalls";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

export const mainMenuList = [
  {
    id: 1,
    title: "Dashboard",
    url: "/dashboard",
    icon: <DonutSmallIcon />,
    childMenuFlag: false,
  },

 

  {
    // Purchase Order menu — its own permission id (10) so it can be granted
    // independently of Invoice (2) and CDN (9). Route guard: /purchase-order/*.
    id: 10,
    title: "Purchase Order",
    url: "#",
    icon: <ShoppingCartRounded />,
    childMenuFlag: true,
    menuOpenFlag: false,
    // Child ids follow parentId*100+n so they stay unique and traceable to
    // their parent at a glance. Individually configurable in Manage Roles &
    // Positions; granting the parent id alone no longer implies all children.
    childMenu: [
      {
        id: 1001,
        icon: <EditNoteIcon />,
        title: "Create Purchase Order",
        url: "/purchase-order/add",
      },
      {
        id: 1002,
        icon: <ListAltRounded />,
        title: "Purchase Order List",
        url: "/purchase-order/list",
      },
    ],
  },
  {
    // Consignment Delivery Note (CDN) menu — its own permission id (9) so it can
    // be granted independently of Invoice (2) and Purchase Order (10).
    // Route guard: /proforma-invoice/*.
    id: 9,
    title: "CDN",
    url: "#",
    icon: <DescriptionRounded />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 901,
        icon: <FolderOpenIcon />,
        title: "Create CDN",
        url: "/proforma-invoice/add",
      },
      {
        id: 902,
        icon: <ListAltRounded />,
        title: "CDN List",
        url: "/proforma-invoice/list",
      },
    ],
  },
  {
    // Proforma menu — standalone clone of CDN above (own table/number
    // sequence, own permission id 11) so it's granted independently of CDN,
    // Invoice, and Purchase Order. Route guard: /proforma-quote/*.
    id: 11,
    title: "Proforma",
    url: "#",
    icon: <RequestQuoteIcon />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 1101,
        icon: <EditNoteIcon />,
        title: "Proforma Creation",
        url: "/proforma-quote/add",
      },
      {
        id: 1102,
        icon: <ListAltRounded />,
        title: "Proforma List",
        url: "/proforma-quote/list",
      },
    ],
  },
   {
    // FOC (Free of Charge) Approval — own permission id (12) so it can be
    // granted independently, e.g. to the Chief Executive's position, without
    // handing out full Invoice access. The page itself (/foc/approvals) is
    // reachable by anyone with Invoice access (2) to check request status;
    // this id only controls whether the Approve/Reject buttons render.
    id: 12,
    title: "FOC Approval",
    url: "/foc/approvals",
    icon: <SwapCallsIcon />,
    childMenuFlag: false,
  },
  {
    id: 13,
    title: "Credit Approval",
    url: "/credit-approval/list",
    icon: <VerifiedUserIcon />,
    childMenuFlag: false,
  },
  {
    // Flag a physical stock shortfall at a store; conversion to a zero-cost
    // (FOC) invoice reuses the existing FOC Approval (id 12) pipeline, so
    // this only needs its own id for the flag/list screen itself.
    id: 14,
    title: "Missing Stock",
    url: "/missing-stock/list",
    icon: <DangerousIcon />,
    childMenuFlag: false,
  },
  {
    // Invoice menu — the core invoicing module, keeps the original permission
    // id 2. Purchase Order (10) and CDN (9) now have their own ids so all three
    // are granted independently. Route guard: /invoice/* and /order/*.
    id: 2,
    title: "Invoice",
    url: "#",
    icon: <ReceiptLongRounded />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 201,
        icon: <ReceiptIcon />,
        title: "Invoice Creation",
        url: "/invoice/add",
      },
      {
        id: 202,
        icon: <ListAltRounded />,
        title: "Invoice List",
        url: "/invoice/list",
      },
       {
        id: 203,
        icon: <HistoryIcon />,
        title: "Invoice History",
        url: "/invoice/transaction-report",
      },
      // Permission-only toggle — not a real page, so it never renders as a
      // sidebar link (see the `permissionOnly` filter below). Create access
      // is just "Invoice Creation" (201) above — granting/revoking that
      // already gates the Create Invoice button on the Invoice List page, so
      // there's no separate "Create" toggle. Edit has no equivalent sidebar
      // page (invoices are edited from the list, not a standalone link), so
      // it still needs its own toggle here to drive can_edit_invoice.
      {
        id: 205,
        icon: <EditNoteIcon />,
        title: "Edit",
        url: "#",
        permissionOnly: true,
      },
    ],
  },
  {
    id: 3,
    title: "Inventory",
    url: "#",
    icon: <Inventory2Icon />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 301,
        icon: <DashboardIcon />,
        title: "Product Inventories",
        url: "/product/list",
      },
      { id: 302, icon: <AddBoxIcon />, title: "Add Product", url: "/product/add" },
      {
        id: 303,
        icon: <CompareArrowsIcon />,
        title: "Stock Adjustment",
        url: "/inventory/add",
      },
      // { title: "Stock History", url: "/inventory/inventory-report" },
      {
        id: 304,
        icon: <LocalShippingIcon />,
        title: "Stock Transfer",
        url: "/stock/transfer",
      },
    ],
  },
  {
    id: 4,
    title: "Masters",
    url: "#",
    icon: <StorageIcon />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 401,
        icon: <GroupRounded />,
        title: "Manage Vendors",
        url: "/customer/list",
      },
      { id: 402, icon: <StorefrontRounded />, title: "Supplier Creation", url: "/vendor/list" },
      { id: 403, icon: <StoreMallDirectoryIcon />, title: "Source", url: "/store/list" },
      {
        id: 404,
        icon: <BookmarksIcon />,
        title: "Purchase Order - Terms & Conditions",
        url: "/terms/list/purchase",
      },
      {
        id: 405,
        icon: <PolicyIcon />,
        title: "Invoice Terms & Conditions",
        url: "/terms/list/sales",
      },
    ],
  },
  {
    id: 7,
    title: "Reports",
    url: "#",
    icon: <SummarizeIcon />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 701,
        icon: <PointOfSaleIcon />,
        title: "Sales Report",
        url: "/reports/sales-report",
      },
      {
        id: 702,
        icon: <Inventory2Icon />,
        title: "Stock Inventory Report",
        url: "/reports/stock-report",
      },
      {
        id: 703,
        icon: <SwapHorizIcon />,
        title: "Stock Transaction Report",
        url: "/reports/transaction-report",
      },
      {
        id: 710,
        icon: <AssessmentIcon />,
        title: "Stock Ledger",
        url: "/reports/stock-ledger",
      },
      {
        id: 704,
        icon: <CompareArrowsIcon />,
        title: "Stock Adjustment Report",
        url: "/reports/adjustment-report",
      },
      {
        id: 705,
        icon: <DangerousIcon />,
        title: "Damaged Products Report",
        url: "/invoice/damaged-report",
      },
      {
        id: 706,
        icon: <SummarizeIcon />,
        title: "Statement of Account",
        url: "/reports/customer-statement",
      },
      {
        id: 707,
        icon: <ReceiptIcon />,
        title: "FOC Given Report",
        url: "/reports/foc-report",
      },
      {
        id: 708,
        icon: <TrackChangesIcon />,
        title: "Sales Target Report",
        url: "/reports/sales-target-report",
      },
      {
        id: 709,
        icon: <AdsClickIcon />,
        title: "Set Sales Targets",
        url: "/sales-targets",
      },
    ],
  },
  {
    // Configurable menu — visible only to roles whose `menus` list includes 8.
    id: 8,
    title: "Call Log",
    url: "#",
    icon: <PhoneInTalkIcon />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 801,
        icon: <CallReceivedIcon />,
        title: "Add Call Log",
        url: "/sales-call-report/add",
      },
      {
        id: 802,
        icon: <SummarizeRounded />,
        title: "Call Log Report",
        url: "/sales-call-report/list",
      },
    ],
  },
  {
    id: 5,
    title: "Configurations",
    url: "#",
    icon: <ToggleOnIcon />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 501,
        icon: <SettingsRounded />,
        title: "Configuration",
        url: "/config/configuration",
      },
      {
        id: 502,
        icon: <CorporateFareIcon />,
        title: "Manage Departments",
        url: "/config/departments-master",
      },
      {
        id: 503,
        icon: <WorkOutlineIcon />,
        title: "Manage Roles & Positions",
        url: "/config/positions-master",
      },
      {
        id: 504,
        icon: <BusinessIcon />,
        title: "Manage Companies",
        url: "/manage-companies/list",
      },
    ],
  },
  {
    id: 6,
    title: "HR Management",
    url: "#",
    icon: <ManageAccountsIcon />,
    childMenuFlag: true,
    menuOpenFlag: false,
    childMenu: [
      {
        id: 601,
        icon: <BadgeIcon />,
        title: "Employees Management",
        url: "/employee/list",
      },
    ],
  },
];

// Given the logged-in user, return the menu items their role is allowed to
// see — now filtered down to individual child items too, not just parents.
//
// Backward compatibility: existing positions (saved before child ids existed)
// only ever have parent ids in their `menus` CSV, e.g. "1,2,3,7". For those,
// granting the parent still means "show every child under it" — the same
// behavior as before. Only once a position is re-saved with specific child
// ids present does that parent's list narrow down to just those children.
const getFilteredMenuFor = (userData) => {
  if (!userData) return [];

  // Extract menu permissions from userData (always respect menus string)
  const allowedMenus = userData.menus
    ? userData.menus.split(",").map((id) => parseInt(id.trim(), 10))
    : [];
  const allowedSet = new Set(allowedMenus);

  // Dashboard (ID 1) is always accessible and visible to all logged-in users.
  allowedSet.add(1);

  // Credit Approval (ID 13) is accessible to users with FOC Approval (12), Invoice (2), ID 13, or Admin position
  if (
    allowedSet.has(12) ||
    allowedSet.has(2) ||
    allowedSet.has(13) ||
    [295, 377].includes(Number(userData.role_id))
  ) {
    allowedSet.add(13);
  }

  // Chief Executive always gets every menu, including any added later — no
  // gating. role_id is NOT a fixed constant across environments (the CE
  // position's auto-increment role_id differs between dev and live), so
  // matching only role_id === 377 silently gated CE in live and hid newer
  // menus like Stock Ledger. Match on position_name — the same reliable check
  // used elsewhere (SUPER_ADMIN_POSITIONS in CustomersList) — and keep 377 as
  // a fallback for older sessions that may lack position_name.
  const ceName = (userData.position_name || "").trim().toLowerCase();
  if (ceName === "chief executive" || Number(userData.role_id) === 377) {
    return mainMenuList;
  }

  return mainMenuList
    .filter((item) => allowedSet.has(item.id))
    .map((item) => {
      if (!item.childMenuFlag) return item;
      const grantedChildren = item.childMenu.filter((c) =>
        allowedSet.has(c.id)
      );
      // No child ids explicitly granted for this parent → legacy grant,
      // keep every child visible. Otherwise, narrow to just what's granted.
      return grantedChildren.length > 0
        ? { ...item, childMenu: grantedChildren }
        : item;
    });
};

// First path segment, e.g. "/product/edit/5" -> "/product".
const firstSegment = (url) => "/" + (url || "").split("/").filter(Boolean)[0];

// Find the (filtered) index of the parent menu that owns the current route,
// so the correct section can be opened on the very first render. Falls back to
// matching the first path segment so detail/edit pages (e.g. /product/edit/5)
// still keep their parent section open. Returns -1 when nothing matches.
const findMenuIndexByPath = (menuArr, path) => {
  let exact = -1;
  let prefix = -1;

  menuArr.forEach((item, index) => {
    if (item.url && item.url !== "#" && item.url === path) {
      exact = index;
    }
    (item.childMenu || []).forEach((child) => {
      if (child.url === path) {
        exact = index;
      } else if (child.url && firstSegment(child.url) === firstSegment(path)) {
        prefix = index;
      }
    });
  });

  return exact >= 0 ? exact : prefix;
};

function Sidenav({ menuOpenedFlag, setMenuState }) {
  const activeUrl = window.location.pathname;
  const userData = JSON.parse(localStorage.getItem("user"));

  // Open the section that owns the current route on first render. Because every
  // page mounts its own <Layout> (and therefore its own <Sidenav>), deriving
  // this synchronously from the URL at mount time — instead of defaulting to 0
  // and correcting it inside an effect — stops the active parent from briefly
  // closing and re-opening on each navigation.
  const [selectedIndex, setSelectedIndex] = React.useState(() => {
    const idx = findMenuIndexByPath(getFilteredMenuFor(userData), activeUrl);
    return idx >= 0 ? idx : null;
  });

  const handleClick = (index) => {
    setSelectedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  // Early return if no user data
  if (!userData) {
    return null;
  }

  // "Invoice Creation" (id 201) already only appears when granted, via
  // getFilteredMenuFor below — no separate invoice-create flag to check
  // anymore, that link *is* the create permission. Just drop permission-only
  // entries (e.g. the Invoice menu's "Edit" toggle) — they exist purely to
  // drive can_edit_invoice and have no page of their own, so they'd
  // otherwise show up as dead links.
  const filteredMenu = getFilteredMenuFor(userData).map((item) => {
    if (!item.childMenuFlag) return item;
    return {
      ...item,
      childMenu: item.childMenu.filter((submenu) => !submenu.permissionOnly),
    };
  });

  return (
    <Grid>
      {filteredMenu.map((row, index) => (
        <React.Fragment key={`${row.id}-${index}`}>
          {row.childMenuFlag ? (
            <>
              <ListItemButton
                className={`menu_id ${selectedIndex === index ? "active" : ""}`}
                onClick={() => handleClick(index)}
              >
                <ListItemIcon>{row.icon}</ListItemIcon>
                <ListItemText primary={row.title} />
                {/* A single icon rotated via CSS reads as a smooth open/close
                    animation; swapping between two different icons (the old
                    ExpandLess/ExpandMore approach) just snaps instantly. The
                    rotation itself lives in App.css (`.menu_id.active > svg`)
                    rather than an inline sx transform, because the icon also
                    needs `translateY(-50%)` for vertical centering — that
                    positioning rule already lives in App.css and would fight
                    a separately-applied inline transform. */}
                <ExpandMore />
              </ListItemButton>
              <Collapse
                in={index === selectedIndex}
                timeout="auto"
                unmountOnExit
              >
                {row.childMenu.map((submenu, subIndex) => (
                  <Link
                    to={submenu.url}
                    key={subIndex}
                    className={`sidemenu--item sidemenu--child ${
                      activeUrl === submenu.url ? "active" : ""
                    }`}
                    onClick={() => {
                      if (!menuOpenedFlag) {
                        setMenuState(false, false); // sidebar remains small
                      }
                    }}
                  >
                    <ListItemButton sx={{ minHeight: 48, px: 2.5 }}>
                      <ListItemIcon>{submenu.icon}</ListItemIcon>
                      <ListItemText primary={submenu.title} />
                    </ListItemButton>
                  </Link>
                ))}
              </Collapse>
            </>
          ) : (
            <Link
              to={row.url}
              key={row.id}
              className={`sidemenu--item ${
                activeUrl === row.url ? "active" : ""
              }`}
              onClick={() => {
                if (!menuOpenedFlag) {
                  setMenuState(false, false); // sidebar remains small
                }
              }}
            >
              <ListItemButton sx={{ minHeight: 48, px: 2.5 }}>
                <ListItemIcon sx={{ minWidth: 0, justifyContent: "center" }}>
                  {row.icon}
                </ListItemIcon>
                <ListItemText primary={row.title} />
              </ListItemButton>
            </Link>
          )}
        </React.Fragment>
      ))}
    </Grid>
  );
}

export default Sidenav;
